import { render, staticRenderFns } from "./BuchungssaetzeTable.vue?vue&type=template&id=bf81a516&"
import script from "./BuchungssaetzeTable.vue?vue&type=script&lang=ts&"
export * from "./BuchungssaetzeTable.vue?vue&type=script&lang=ts&"
import style0 from "./BuchungssaetzeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports